import { db, auth } from './firebaseconfig';
import { 
  createUserWithEmailAndPassword, 
  deleteUser, 
  updateEmail, 
  updatePassword,
  signInWithEmailAndPassword
} from 'firebase/auth';
import { 
  collection, 
  addDoc, 
  getDocs, 
  getDoc,
  doc, 
  deleteDoc, 
  setDoc,
  updateDoc, 
  query, 
  orderBy 
} from 'firebase/firestore';

// Crear un nuevo usuario
export const createUser = async (userData) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, userData.email, userData.password);
    const user = userCredential.user;

    // Usar el ID de Auth como nombre del documento en Firestore
    await setDoc(doc(db, 'users', user.uid), {
      name: userData.name,
      email: userData.email,
      area: userData.area,
      user: userData.user
    });

    return { success: true, message: 'Usuario creado exitosamente' };
  } catch (error) {
    console.error('Error al crear usuario:', error);
    return { success: false, message: 'Error al crear usuario: ' + error.message };
  }
};

// Obtener todos los usuarios
export const getUsers = async () => {
  try {
    const usersQuery = query(collection(db, 'users'), orderBy('name', 'asc'));
    const querySnapshot = await getDocs(usersQuery);
    const usersData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    return { success: true, users: usersData };
  } catch (error) {
    console.error('Error al obtener usuarios:', error);
    return { success: false, message: 'Error al obtener usuarios: ' + error.message };
  }
};

const API_URL = 'https://gestionapp-b3k6.onrender.com';

// Actualizar un usuario
export const updateUser = async (userId, userData) => {
  try {
    const userRef = doc(db, 'users', userId);
    await updateDoc(userRef, userData);
    return { success: true, message: 'Datos del usuario actualizados exitosamente' };
  } catch (error) {
    console.error('Error al actualizar datos del usuario:', error);
    return { success: false, message: 'Error al actualizar datos del usuario: ' + error.message };
  }
};

// Nueva función para actualizar la contraseña sin requerir la contraseña actual
export const updateUserPassword = async (uid, newPassword) => {
  try {
    const response = await fetch(`${API_URL}/api/changePassword`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ uid, newPassword }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al actualizar contraseña:', error);
    return { success: false, message: 'Error al actualizar contraseña: ' + error.message };
  }
};

// Eliminar un usuario
export const deleteUserFunction = async (userId) => {
  try {
    console.log('Attempting to delete user with ID:', userId);
    const response = await fetch(`${API_URL}/api/deleteUser`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ uid: userId }),
    });

    console.log('Delete user response status:', response.status);
    console.log('Response headers:', Object.fromEntries(response.headers));

    const textResponse = await response.text();
    console.log('Raw response:', textResponse);

    let data;
    try {
      data = JSON.parse(textResponse);
    } catch (parseError) {
      console.error('Error parsing JSON:', parseError);
      return { success: false, message: `Failed to parse server response: ${textResponse}` };
    }

    if (!response.ok) {
      console.error('Server responded with an error. Status:', response.status);
      console.error('Error details:', data);
      return { success: false, message: `HTTP error! status: ${response.status}, message: ${data.message || 'Unknown error'}` };
    }

    console.log('Delete user response data:', data);
    return data;
  } catch (error) {
    console.error('Error in deleteUserFunction:', error);
    return { success: false, message: 'Error al eliminar usuario: ' + error.message };
  }
};
